import MessageModal from './MessageModal';
import './MessageModal.scss';

export default MessageModal;
